import React from 'react';
import '../styles/LoadingIndicator.css'; // Import the CSS file

const LoadingIndicator = () => {
  return (
    <div className="loading-indicator">
      <div className="spinner"></div>
      <div>Loading, please wait...</div>
    </div>
  );
};

export default LoadingIndicator;
